import { CoverageIdEnum } from 'outshared-lib';
import { CoverageTableConfigInterface } from '../interfaces';

export const coverageCarData: CoverageTableConfigInterface = {
    descriptions: [
        {label: 'Schade aan andere auto\'s'},
        {label: 'Ruitbreuk- en barsten'},
        {label: 'Diefstal, brand en storm'},
        {label: 'Schade aan eigen auto'},
        {label: 'Nieuwwaarde bij total loss of diefstal'},
        {label: 'Aanschafwaarde bij total loss of diefstal'},
    ],
    items: [
        {
            id: CoverageIdEnum.CarLegalLiability,
            title: 'WA',
            subtitle: null,
            note: null,
            noteSmall: null,
            options: [
                { type: 'boolean', value : true },
                { type: 'boolean', value : false },
                { type: 'boolean', value : false },
                { type: 'boolean', value : false },
                { type: 'boolean', value : false },
                { type: 'boolean', value : false },
            ],
        },
        {
            id: CoverageIdEnum.CarLimitedCasco,
            title: 'Beperkt Casco',
            subtitle: null,
            note: null,
            noteSmall: null,
            options:  [
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : false },
                { type: 'string', value : 'tot 2 jaar' },
                { type: 'string', value : 'tot 2 jaar' },
            ],
        },
        {
            id: CoverageIdEnum.CarLimitedCascoExtra,
            title: 'Beperkt Casco EXTRA',
            subtitle: null,
            note: null,
            noteSmall: null,
            options: [
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'string', value : '50%'  },
                { type: 'string', value : 'tot 2 jaar' },
                { type: 'string', value : 'tot 2 jaar' },
            ],
        },
        {
            id: CoverageIdEnum.CarAllrisk,
            title: 'Allrisk',
            subtitle: null,
            note: null,
            noteSmall: null,
            options:  [
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'boolean', value : true },
                { type: 'string', value : '100%'  },
                { type: 'string', value : 'tot 3 jaar' },
                { type: 'string', value : 'tot 3 jaar' },
            ],
        },
    ],
    rows: [],
};
